import { useFormWithValidation } from "@/features/forms/hooks/useFormWithValidation";
import { FormProvider } from "react-hook-form";
import FormInput from "@/features/forms/components/FormInput";
import Spinner from "@/features/forms/components/Spinner";
import { useEditSettings } from "@/features/settings/hooks/useEditSettings";

import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";

import style from "./RegisterSettingsStep.module.css";
import InputPhone from "@/features/forms/components/InputPhone";

function RegisterSettingsStep({ user, nextStep }) {
	const formMethods = useFormWithValidation({
		defaultValues: {
			username: user.username,
			first_name: user.firstName,
			last_name: user.lastName,
		},
	});

	const {
		handleSubmit,
		formState: { isSubmitting },
	} = formMethods;

	const { save } = useEditSettings();

	const onSubmit = async function (data) {
		await save(data);
		nextStep();
	};

	return (
		<div className={style.content}>
			<div className={style.header}>
				<Icon icon="fa-user" />
				<h2>Unos ličnih informacija</h2>
			</div>
			<FormProvider {...formMethods}>
				<form className={style.form} onSubmit={handleSubmit(onSubmit)}>
					<FormInput
						name="username"
						autoComplete="username"
						label="Korisničko ime"
						placeholder="korisnik123"
						required
					/>
					<FormInput
						name="first_name"
						label="Ime"
						placeholder="Unesite ime"
						required
					/>
					<FormInput
						name="last_name"
						label="Prezime"
						placeholder="Unesite prezime"
						required
					/>
					<div className={style.buttonHolder}>
						<Button disabled={isSubmitting} type="accent">
							{isSubmitting ? <Spinner /> : "Nastavi"}
						</Button>
					</div>
				</form>
			</FormProvider>
		</div>
	);
}

export default RegisterSettingsStep;
